<template lang="pug">
#detail.background
  DetailModal(
    v-if='orderId && modalOpen',
    :orderId='orderId',
    :category="gameCategory"
    @modalClose='modalOpen = false'
  )
  .mask(v-if='isShow')
  .container.col(v-if='this.loadingStatus === "completed"')
    header {{ $t("title") }}
    //- .sub_title {{$t('subTitle')}}
    //- .user_info.row
    //-   .account {{$t('account')}}: {{printNoDataIfNeeds(account)}}
    //-   span |
    //-   .parent_account {{$t('proxy')}}: {{printNoDataIfNeeds(parentAccount)}}
    .table
      .tr.col
        //- 會員帳號
        .td.row
          .title.row {{ $t("account") }}
          .content.col {{ printNoDataIfNeeds(account) }}
        //- 遊戲名稱
        .td.row
          .title.row {{ $t("gameName") }}
          .content.col {{ gameName }}
        //- 期號
        .td.row
          .title.row {{ $t("round") }}
          .content.col {{ printNoDataIfNeeds(gameRound) }}
        //- 投注內容
        .td.row.content.col
          .title.row {{ $t("betContents") }}
          .content.col
            div {{ `【${$record_label(betInfo.label, betInfo.odds.key)}】` }}
            template(v-if='Array.isArray(betItem)')
              .bet_item(v-for='(item, titleIndex) in betItem')
                template(v-if='item.title') {{ `${item.title} : ` }}
                template(v-for='(num, numInd) in item.num') {{ $t(num) }}
                  sapn(v-if="betInfo.label.includes('ConcatPass')") {{ ` @${betInfo.odds_options[titleIndex].value}` }}
                  span(v-if='numInd + 1 < item.num.length') {{ ", " }}
            template(v-else)
              div {{ megaSet ? $t(translBetKeyFunc(betInfo.odds.key)) : $t(betItem) }}
              div @{{ betInfo.odds.value }}
            template(v-if="betInfo.label === 'PrizeTotalIndex'")
              div {{ $t('multipart') }}:{{ multiples }}
              div {{ $t('deno') }}:{{ deno }}
            a(v-if='showTotalAmount(betInfo.label)', @click='modalOpen = true') {{ `${$t('per_page_total_combo', { n: totalBetAmount / deno })} $ ${deno}` }}
        //- 開獎結果
        .td.row.result
          .title.row {{ $t("result") }}
          //- 泰國彩
          .content.col(v-if="this.gameCategory === 'THAI'")
            .result(
              v-for='(item, index) in resultBall.normal',
            )
              span(class="resultTitle") {{ $t(`${item.title}`) }}
              span {{ item.number }}
          .content.col(v-else)
            //- 球
            .row.ball_wrapper(:class="{ flex_wrap: megaSet }")
              .ball(
                v-for='(num, index) in resultBall.normal',
                :class="[ballColor(num), megaSet ? 'megaBall' : '']"
              ) {{ num }}
              template(v-if='resultBall.sp')
                | +
                .ball(:class='ballColor(resultBall.sp)') {{ resultBall.sp }}
            .row.ball_wrapper(v-if="!megaSet")
              .square(v-for='(num, index) in resultBall.normal')
                img(:src='getYearImg(YearNumbers(num))')
              template(v-if='resultBall.sp')
                | +
                .square
                  img(:src='getYearImg(YearNumbers(resultBall.sp))')
            template(v-if='taiNumOn && Object.keys(result).length > 0')
              .row.ball_wrapper.taiNum
                .ball(v-for='(num, index) in taiNum(result)') {{ num }}
              .spThree {{ `${$t("SpThree")}: ${SpThree(taiNum(result))}` }}
      .tr.col
        //- 投注時間
        .td.row
          .title.row {{ $t("betTime") }}
          .content.col {{ printNoDataIfNeeds(this.$_MOMENT.unix(createdTime).format("YYYY-MM-DD HH:mm:ss")) }}
        //- 注單號
        .td.row
          .title.row {{ $t("orderID") }}
          .content.col {{ orderAgo }}{{ printNoDataIfNeeds(orderId) }}
        //- 投注金額
        .td.row
          .title.row {{ $t("betAmount") }}
          .content.col {{ showDecimal(printNoDataIfNeeds(totalBetAmount)) }}
        //- 注單狀態
        .td.row
          .title.row {{ $t("bet_status") }}
          .content.col {{ parseStatusText(status) }}
        //- 有效投注
        .td.row
          .title.row {{ $t("validBets") }}
          .content.col {{ showDecimal(printNoDataIfNeeds(validBet)) }}
        //- 派彩金額
        .td.row
          .title.row {{ $t("totalWin") }}
          .content.col {{ showDecimal(printNoDataIfNeeds(totalWinAmount)) }}
        //- 返水狀態
        .td.row
          .title.row {{ $t("rebate_status") }}
          .content.col {{ rebateStatusText(rebateStatus) }}
        //- 返水金額
        .td.row
          .title.row {{ $t("rebate_amount") }}
          .content.col {{ showDecimal(printNoDataIfNeeds(rebate)) }}
        //- 遊戲損益
        .td.row
          .title.row.row {{ $t("gameProfit") }}
            .icon_wrapper(ref='icon_wrapper')
              .icon(@click='isShow = !isShow')
                .small ⅰ
                input#icon_toggle(ref='icon_toggle', @blur='blur')
              .outer(v-if='isShow')
                .arrow
                div
                  p(v-html='$t("gameProfitRule")')
          .content.col(:style='negativeNumberColor(betProfit)') {{ showDecimal(printNoDataIfNeeds(betProfit)) }}
        //- 備註
        .td.row
          .title.row {{ $t("remark") }}
          .content.col {{ $_remarkStatus(profitType) }}
  header.warning(v-if='loadingStatus === "fail"') {{ $t("noData") }}
</template>

<script>
import tableHead from './scripts/tableHead'
import BaseBall from '@/components/BaseBall'
import BaseImg from '@/components/BaseImg'
import DetailModal from '@/components/DetailModal'
import translator from '@/utils/translator'
import record from '@/mixins/record'
import common from '@/mixins/common.js'

const url = new URLSearchParams(window.location.search)

export default {
  name: 'DetailPage',
  components: {
    BaseBall,
    BaseImg,
    DetailModal
  },
  mixins: [translator, record, common],
  data () {
    return {
      zodicYearNumbers: {},
      tableHead,
      account: '',
      parentAccount: '',
      gameName: '',
      orderId: '',
      createdTime: Number,
      status: Number,
      transl: '',
      betInfo: {},
      multiples: Number,
      totalBetAmount: Number,
      totalWinAmount: Number,
      paidAt: Number,
      settledAt: Number,
      repaidAt: Number,
      gameRound: Number,
      result: {},
      gameId: '',
      gameCategory: '',
      gameLotto: '',
      profitType: Number,
      betProfit: 0,
      url: '',
      location: '',
      locale: 'en-us',
      token: '',
      deno: Number,
      loadingStatus: 'loading',
      rebate: 0,
      rebateStatus: 0,
      validBet: '',
      // 東南亞獎號之位數
      prizeDigits: {
        VI27: {
          1: 5,
          2: 5,
          3: 5,
          4: 4,
          5: 4,
          6: 3,
          7: 2,
          sp: 5
        },
        VI18: {
          1: 5,
          2: 5,
          3: 5,
          4: 5,
          5: 4,
          6: 4,
          7: 3,
          8: 2,
          sp: 6
        },
        THAI: {
          1: 6,
          2: 3,
          3: 3,
          4: 2
        }
      },
      orderAgo: process.env.VUE_APP_ORDER_AGO,
      isShow: false,
      LH06Color: {
        ball_r: [
          1,
          2,
          7,
          8,
          12,
          13,
          18,
          19,
          23,
          24,
          29,
          30,
          34,
          35,
          40,
          45,
          46
        ],
        ball_b: [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48],
        ball_g: [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]
      },
      modalOpen: false,
      mouse: undefined
    }
  },
  computed: {
    betItem () {
      return this.$record_betItem(
        this.betInfo.items || [],
        this.betInfo.odds.key,
        this.betInfo.label
      )
    },
    iconQuestion () {
      return require(`@/assets/icons/icon-question.svg`)
    },
    establishedTime () {
      if (this.paidAt > 0) return this.$_MOMENT.unix(this.paidAt).format()
      return 'unestablished'
    },
    isAmendTimeShow () {
      return this.repaidAt > 0
    },
    isResultShow () {
      return Object.keys(this.result).length !== 0
    },
    resultBall () {
      // 泰國彩
      if (this.gameCategory === 'THAI') {
        const res = this.result || {}
        const groups = {}

        // 依照 "-" 前半段 (1,2,3,4...) 分組
        Object.entries(res).forEach(([key, value]) => {
          if (key === 'sp') return // 保留 sp 給下面用
          const [group] = key.split('-')
          if (!groups[group]) groups[group] = []
          groups[group].push(value)
        })

        // 預設標題
        const thResultTitle = [
          'TH_prize1-1',
          'TH_prize2-1',
          'TH_prize3-1',
          'TH_prize4-1'
        ]

        // 把每組組成 { title, number }
        const normal = Object.values(groups).map((arr, index) => ({
          title: thResultTitle[index],
          number: arr.join(' / ')
        }))

        return {
          normal,
          sp: res.sp || null
        }
      }

      const temp = {
        normal: Object.values(this.result),
        sp: this.result.sp
      }
      if (temp.sp) temp.normal.pop()
      return temp
    },
    ballSize () {
      if (
        (this.gameCategory === 'JOY8' || this.gameCategory === 'PK10') &&
        window.innerWidth < 416
      ) {
        return 16
      }
      if (this.gameCategory === 'JOY8' || this.gameCategory === 'PK10') {
        return 22
      }
      return 24
    },
    punctuationSize () {
      if (window.innerWidth < 416) return 8
      return 10
    },
    isSoutheastAsia () {
      return ['VI18', 'VI27', 'THAI'].includes(this.gameCategory)
    },
    taiNumOn () {
      let th
      switch (this.gameCategory) {
        case 'LHO6':
        case 'DLTO':
          th = true
          break
        case 'JC539':
        case 'USJOY':
          th = false
          break
      }
      return th
    },
    point () {
      const input = document
        .getElementById('modal_body')
        .getBoundingClientRect()
      const Anchor = document
        .getElementById('icon_wrapper')
        .getBoundingClientRect()
      return {
        input, Anchor
      }
    },
    megaSet () {
      return ['KENO', 'PK10'].includes(this.gameCategory)
    }
  },
  watch: {
    // 如果沒有Amend Time, tableHead中的AmendTime也不會出現
    repaidAt () {
      if (this.isAmendTimeShow) return
      const index = this.tableHead.tableTwo.indexOf('amendTime')
      this.table = this.tableHead.tableTwo.splice(index, 1)
    },
    isShow () {
      if (this.isShow) {
        document.getElementById('icon_toggle').focus()
        window.addEventListener('mousedown', this.mouseListener)
      } else {
        window.removeEventListener('mousedown', this.mouseListener)
      }
    }
  },
  created () {
    if (process.env.VUE_APP_NETWORK_MAINTENANCE === 'on') {
      this.getMaintainStatus()
    }
  },
  mounted () {
    this.loadingStatus = 'loading'

    // this.token = url.get('token')
    // 沒帶language參數就不判斷了，會直接帶入data預設的en-us
    const language = url.get('language')
    if (language) {
      switch (language.toLowerCase()) {
        case 'en-us':
        case 'en':
          this.locale = 'en-us'
          break

        default:
          this.locale = 'zh-cn'
          break
      }
    }
    // 用moment-timezone抓取客戶端時區
    // this.location = this.$_MOMENT.tz.guess().replace('/', '-')

    this.getDetail()
  },
  methods: {
    async getMaintainStatus () {
      const lang = url.get('language') || 'en-us'
      try {
        const params = {
          agent: url.get('agent'),
          general_agent: url.get('general_agent')
        }
        const res = await this.$_AXIOS.get(
          `${process.env.VUE_APP_MAINTAIN_API_URL}/internet/maintain/gc/list`,
          { params }
        )
        const { data } = res.data

        if (data.maintain_status === 1) {
          location.href = `${process.env.VUE_APP_FIX_PAGE_URL}/block/maintenance?lang=${lang}`
        }
      } catch (error) {
        console.log(error)
        location.href = `${process.env.VUE_APP_FIX_PAGE_URL}/block/maintenance?lang=${lang}`
      }
    },
    getDetail () {
      const params = {
        // agent: url.get('agent_id'),
        // general_agent: url.get('general_agent'),
        // user_id: url.get('user_id'),
        order_id: url.get('order_id')
      }
      const headers = {
        locale: url.get('language')
      }
      this.$_AXIOS
        .get('/game/f2e/ml/record/detail-order', {
          params,
          headers
        })
        .then(res => {
          let data = res.data.data.detail
          // 如果detail不為空物件才繼續, 否則throw error
          if (res.data.data.account !== '') {
            // 沒有包在detail中的資料
            this.account = res.data.data.account
            this.parentAccount = res.data.data.parent_account

            this.result = res.data.data.result
            this.betProfit = res.data.data.bet_profit
            // detail中的資料
            this.orderId = data.id
            this.createdTime = data.created_time
            this.status = data.status
            this.transl = data.transl
            this.multiples = data.multiples
            this.totalBetAmount = data.total_bet_amount
            this.totalWinAmount = data.total_win_amount
            this.paidAt = data.paid_at
            this.settledAt = data.settled_at
            this.repaidAt = data.repaid_at
            this.gameRound = data.game_round
            this.gameId = data.game_id
            this.betInfo = data.bet_info
            this.gameCategory = data.category
            this.gameLotto = data.lotto
            this.profitType = data.profit_type
            this.rebate = data.rebate
            this.rebateStatus = data.rebate_status
            this.validBet = data.valid_bet
            this.deno = data.deno

            // 需要先判斷上層物件是否存在的資料
            // 這裏如果用if else判斷會過於冗贅, 因此還是使用三元運算子
            // this.gameName = res.data.data.game_name
            this.gameName = this.$t(res.data.data.game_name)
            const ns = [`games/${this.gameCategory}`, 'general', 'phase']
            this.$i18n.i18next.reloadResources(null, ns)
            this.$i18n.i18next.setDefaultNamespace(ns)
            this.getYearNumbers()
            this.loadingStatus = 'completed'
          } else {
            this.loadingStatus = 'fail'
          }
        })
        .catch(() => {
          this.loadingStatus = 'fail'
        })
      // .then(() => {
      //   // 避免上面loadingStatus已經為fail又被改回來的情況
      //   if (this.loadingStatus === 'fail') return
      //   setTimeout(() => {
      //     this.loadingStatus = 'completed'
      //   }, 1000)
      // })
    },
    getYearNumbers () {
      const params = {
        // agent: url.get('agent_id'),
        // general_agent: url.get('general_agent'),
        // user_id: url.get('user_id'),
        // order_id: url.get('order_id'),
        game_id: this.gameId
      }
      const headers = {
        locale: url.get('language')
      }
      this.$_AXIOS
        .get(`/v2/ml/game/year-numbers`, {
          params,
          headers
        })
        .then(res => {
          this.zodicYearNumbers = res.data.data.zodics
        })
        .catch(err => {
          console.error(err)
        })
    },
    // 檢查data有無拿到值，沒有就噴查無資料
    printNoDataIfNeeds (params) {
      // 排除總派彩可能為零的情況
      if (params || params === 0) return params
      return this.$t('noData')
    },
    // 根據傳入的status判斷派彩狀態
    // 1:已中獎, 2:未中獎, 3:等待開獎, 4:已註銷, 5:系統取消, 6:和局, 7:等待派彩
    // 如果派彩狀態為無法顯示時間的情況 => 將總派彩改為'-'
    parseStatus (status) {
      switch (status) {
        case 1:
        case 2:
        case 6:
          return this.$_MOMENT.unix(this.settledAt).format()

        case 4:
        case 5:
          this.totalWinAmount = '0.00'
          return 'cancel'

        case 3:
          this.totalWinAmount = '-'
          return '-'

        case 7:
          this.totalWinAmount = '-'
          return 'waitForMoney'

        default:
          this.totalWinAmount = '-'
          return 'noData'
      }
    },
    parseStatusText (status) {
      const keys = {
        1: this.$t('is_winning'),
        2: this.$t('not_winning'),
        3: this.$t('waiting_for_result'),
        4: this.$t('is_cancel'),
        5: this.$t('system_cancel'),
        6: this.$t('is_tie'),
        7: this.$t('wait_for_money')
      }
      return keys[status] || '-'
    },
    rebateStatusText (status) {
      const keys = {
        1: this.$t('hasnt_rebated'),
        2: this.$t('rebated'),
        3: this.$t('no_rebate'),
        4: this.$t('is_cancel')
      }
      return keys[status] || '-'
    },
    resultOddsText (betInfo, gameCategory, gameLotto) {
      const {
        mainText,
        subText,
        groupText,
        itemsText,
        value
      } = this.$_betRecordText(betInfo, gameCategory)

      return {
        betText: `【${mainText}】 ${subText} ${groupText} ${itemsText} `,
        oddsText: `@ ${value}`
      }
    },
    setSoutheastAsiaResultType (obj) {
      if (Object.keys(obj).length === 0) return '-'
      let arr = []
      Object.keys(obj).forEach(e => {
        arr.push(e.split('-')[0])
      })

      let result = [...new Set(arr)]

      // 越南彩特獎需在前
      if (['VI18', 'VI27'].includes(this.gameCategory)) {
        result.unshift(result.pop())
      }

      return result
    },
    $_remarkStatus (status) {
      switch (status) {
        case 1:
          return this.$t('total_bonus_one')

        case 2:
          return this.$t('total_bonus_single')

        case 3:
          return this.$t('recalculate_total_bonus')
      }
    },
    negativeNumberColor (value) {
      const number = Number(value)
      if (isNaN(number)) return {}
      return {
        color: number < 0 ? 'red' : ''
      }
    },
    showTotalAmount (label) {
      const includesArray = [
        'BomFast',
        'Pillar',
        'ThreeWinTwo',
        'TwoWinSp',
        'ZodiacCombo',
        'TailNumCombo',
        'Duplex',
        'AllBom',
        'SpConcat',
        'SelectNumber'
      ]
      const bool = includesArray.some(text => label.includes(text))
      return bool
    },
    // 球色
    ballColor (num) {
      if (['USJOY'].includes(this.gameCategory)) return 'ball_b'
      if (this.gameCategory === 'JC539') {
        switch (num % 3) {
          case 0:
            return 'ball_g'
          case 1:
            return 'ball_r'
          case 2:
            return 'ball_b'
        }
      }
      if (this.gameCategory === 'KENO') {
        if (num > 40) return 'ball_kg'
        if (num <= 40) return 'ball_kr'
      }
      if (this.gameCategory === 'PK10') {
        return `ball_pk10${num}`
      }
      // eslint-disable-next-line standard/computed-property-even-spacing
      return Object.keys(this.LH06Color)[
        Object.values(this.LH06Color)
          .map(x => x.includes(num))
          .indexOf(true)
      ]
    },
    getYearImg (num) {
      if (['KENO'].includes(this.gameCategory)) return
      return require(`@/assets/icons/zodicYear/${num}.svg`)
    },
    YearNumbers (num) {
      // eslint-disable-next-line standard/computed-property-even-spacing
      return Object.keys(this.zodicYearNumbers)[
        Object.values(this.zodicYearNumbers)
          .map(x => x.includes(num))
          .indexOf(true)
      ]
    },
    // 台號
    taiNum (num) {
      const tempNum = JSON.parse(JSON.stringify(num))
      delete tempNum.sp
      const sort = Object.values(tempNum).sort((a, b) => a - b)
      const tail = sort.map(x => x % 10)
      const taiNum = []
      for (let i = 0; i < tail.length - 1; i++) {
        taiNum.push(tail[i] + String(tail[i + 1]))
      }
      return taiNum
    },
    // 特三
    SpThree (taiNum) {
      const tempNum = JSON.parse(JSON.stringify(taiNum))
      const tail = tempNum
        .slice(1, 4)
        .map(x => x % 10)
        .reduce((a, b) => a + String(b))
      return tail
    },
    blur () {
      if (this.$refs.icon_wrapper.contains(this.mouse)) {
        return this.$refs.icon_toggle.focus()
      }

      this.isShow = false
    },
    mouseListener (event) {
      this.mouse = event.target
    }
  }
}
</script>
<style scoped lang="stylus" src="./DetailPage.styl"></style>
